import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";
import * as ACTIONCONSTANTS from '../../actions/ActionConstants';
import { CHANGE_EVENT } from "../../../utilities/Constants";

interface IScannerState {
    state: {
        reload: boolean,
        message: string[]
    }
}
class DeleteStore extends EventEmitter implements IScannerState {
    state: {
        reload: boolean,
        message: string[]
    };
    constructor() {
        super();
        this.state = {
            reload: false,
            message: []
        };
        LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case ACTIONCONSTANTS.SCANNER_SETTING_DELETE:
                    Object.assign(this.state, e.payload);
                    this.emit(CHANGE_EVENT, this.state);
                    break;
            }
        });
    }
}
const scannerDeleteStore = new DeleteStore();

export default scannerDeleteStore;